// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { updateInterferenceAnalysisState } from 'redux/modules/interferenceAnalysis'
import getVisiblePathIds from './getVisiblePathIds'
import getVisibleGroupedFrequencyPlans from './getVisibleGroupedFrequencyPlans'
import removeFilteredFromHighlight from './removeFilteredFromHighlight'

const filterAFSGridPaths = () => (dispatch, getState) => {
  // get the visible path ids based on the filter state.
  const visiblePathIds = dispatch(getVisiblePathIds())

  // transofrm that into a nested structure to render in the UI
  // * this is because of how the paths are grouped by channel plan pairs
  const visibleGroupedFrequencyPlans = dispatch(getVisibleGroupedFrequencyPlans(visiblePathIds))

  // derive the highlighted paths, omitting any paths which are no longer visible
  const highlightedPathIds = dispatch(removeFilteredFromHighlight(visiblePathIds))

  // then update in redux
  dispatch(updateInterferenceAnalysisState({
    highlightedPathIds,
    visibleGroupedFrequencyPlans,
  }))
}

export default filterAFSGridPaths
